import styled from "styled-components";
import BotonSubmit from "../../components/BotonSubmit"
import { colorPrimario} from "../UI/variables";
import { useState } from "react";
import appFirebase from "../../firebase";
import { getFirestore, updateDoc, doc } from "firebase/firestore";
import Entrada from "../Entrada";

const StyledSection=styled.section`
    display: flex;
    flex-direction: column;
    background-color: white;
    width: 312px;
    height: 100%;
    display: flex;
    justify-content: space-between ;
`
const DivEncabezadoCard = styled.div`
    display: flex;
    justify-content: space-between;
    p{
        display: flex;
        width: 100%;
        color: ${colorPrimario};
        margin: 0;
        padding-bottom: 16px;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        font-size: 20px;
    }
`
const DivContenedor=styled.div`
    display: flex;
`
const DivTarjeta=styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`
const DivInformacion=styled.div`
    display: flex;
    width: 100%;
    img{
        width: 104px;
        height: 96px;
    }
    p{
        width: 240px;
    }
`
const StyledText=styled.div`
    display: flex;
    flex-direction: column;
    font-size: 12px;
    justify-content: space-around;
    margin: 0px 0px 0px 8px;
    width: 200px;
    height: 100%;
    p{
        margin: 0;
        width: 200px;
    }
`
const DivMesesPagados=styled.div`
    display: flex;
    margin-top: 16px;
    padding-bottom: 16px;
    border-bottom: dashed 8px black;
`
const DivCuentas=styled.div`
    width: 33.3%;
    &:not(:first-child){
        border-left: solid 1px black;
    }
    h4{
        margin: 0 0 16px 0;
        text-align: center;
        height: 40px;
        font-weight: 500;
        color: ${colorPrimario};
    }
    p{
        margin: 16px 0 16px 0;
        text-align: center;
        height: 40px;
        font-size: 18px;
        font-weight: bold;
    }
`
const PDeuda=styled.p`
    color: red;
`
const PAdelanto=styled.p`
    color: green;
`
const PInstruccion=styled.p`
    font-weight: bold;
`
const StyledEntrada=styled(Entrada)`
 width: 100%;
 box-sizing: border-box;
 height: 32px;
 text-align: center;
 font-size: 20px;
`
const PNota = styled.p`
  margin: -8px 0px 8px 0px;
  font-size: 14px;
  color: red;
  font-weight: bold;
  text-align: center;
`
const BotonRegistroPago=styled(BotonSubmit)`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 8px 0px 0px 0px;
    height: 48px;
    font-size: 16px;
    p{
        color: white;
        margin: 0;
        font-weight: 500;
        font-size: 14px;
    }
`
const HabitacionAdministradaPagos=(props)=>{
    const db = getFirestore(appFirebase);
    const [procesoEnvioIniciado, setProcesoEnvioIniciado] = useState(false);
    const [validacionPago, setValidacionPago] = useState("");

    const mesesDeuda = props.periodoActual-props.periodoPagado

    const manejarValidacionPago = (e) => {
        setValidacionPago(e.target.value);
      };
    
    //*****************************FUNCION PARA SUMAR DIAS***************************** */
    const sumarDias = (fecha, dias) => {
        const fechaSumada = new Date(fecha);
        fechaSumada.setDate(fechaSumada.getDate() + dias);
        return fechaSumada;
    }
    //**************************FUNCION PARA REGISTRAR PAGO*************************** */
    const RegistrarPago = async(e)=>{
        e.preventDefault();
        if(validacionPago==props.precio){
            if(window.confirm(`Estas seguro de registrar el pago del mes ${(props.periodoPagado+1)}?`)){
                setProcesoEnvioIniciado(true);
                const datosRegistro = {
                    periodoPagado: props.periodoPagado+1,
                    fechaInicioPeriodoPorPagar: sumarDias(props.fechaFinPeriodoPorPagar.toDate(), 1),
                    fechaFinPeriodoPorPagar: sumarDias((props.fechaFinPeriodoPorPagar.toDate()), 30),
                    historialPagos: [...props.historialPagos, {precio: props.precio, fecha: new Date(), mes: props.periodoPagado+1}]
                }
                try {
                    const documentoRef = doc(db, "habitaciones", props.idHabitacion);
                    await updateDoc(documentoRef, datosRegistro);
                } catch (error) {
                    console.error("Error al realizar pago:", error);
                }
                alert("Pago Registrado por: S/. " + props.precio)
                setProcesoEnvioIniciado(false);
                setValidacionPago("")
            }
        }else{
            return
        }
    }

    return(
        <StyledSection>
            <DivEncabezadoCard>
                <p>{`${props.tipoAlquiler} N°${props.nroHabitacion}`}</p>
            </DivEncabezadoCard>
            <DivContenedor>
                <DivTarjeta>
                    <DivInformacion>
                        <img src={props.imagen} alt= "Fotografia de la habitacion seleccionada"/>
                        <StyledText>
                            <p><strong>Nombre:</strong>{` ${props.nombreCompleto}`}</p>
                            <p><strong>Celular:</strong>{` ${props.celular}`}</p>
                            <p><strong>Fecha de entrada:</strong>{` ${(props.fechaEntrada).toDate().toLocaleDateString()}`}</p>
                        </StyledText>
                    </DivInformacion>
                    <DivMesesPagados>
                        <DivCuentas>
                            <h4>Precio Habitación: </h4>
                            <p> S/. {props.precio}</p>
                        </DivCuentas>
                        {mesesDeuda * props.precio >=0 
                            ?
                            <DivCuentas>
                                <h4>Meses de deuda:</h4>
                                <PDeuda>{mesesDeuda} meses</PDeuda>
                            </DivCuentas>
                            :
                            <DivCuentas>
                                <h4>Meses de Adelanto:</h4>
                                <PAdelanto>{mesesDeuda*-1} meses</PAdelanto>
                            </DivCuentas>
                        }
                        {mesesDeuda * props.precio >=0 
                            ?
                            <DivCuentas>
                                <h4>Deuda Total:</h4>
                                <PDeuda>S/. {mesesDeuda * props.precio}</PDeuda>
                            </DivCuentas>
                            :
                            <DivCuentas>
                                <h4>Total Adelanto:</h4>
                                <PAdelanto>S/. {(mesesDeuda * props.precio)*-1}</PAdelanto>
                            </DivCuentas>
                        }
                    </DivMesesPagados>
                    <div>
                        <form onSubmit={RegistrarPago}>
                            <PInstruccion>* Para registrar un pago por favor escribe el monto:</PInstruccion>
                            <StyledEntrada onChange={manejarValidacionPago} value={validacionPago} type="number" placeholder="S/." required/>
                            {validacionPago!=="" && validacionPago!=props.precio && (
                                <PNota>Nota: Debe coincidir con el asignado a la habitación</PNota>
                            )}
                            <BotonRegistroPago $procesoenvioiniciado={procesoEnvioIniciado} disabled={procesoEnvioIniciado ? true : false}>
                                Registrar Pago Mes {props.periodoPagado+1}
                                <p>{`${props.fechaInicioPeriodoPorPagar&&props.fechaFinPeriodoPorPagar ? `(${(props.fechaInicioPeriodoPorPagar.toDate()).toLocaleDateString()} - ${(props.fechaFinPeriodoPorPagar.toDate()).toLocaleDateString()})` :<></>}`}</p>
                            </BotonRegistroPago>
                        </form>
                    </div>
                </DivTarjeta>
            </DivContenedor>
        </StyledSection>
    )
}
export default HabitacionAdministradaPagos